/**
 * Breakpoint constants matching SCSS variables in _variables.scss
 * Keep these in sync with $breakpoint-* variables
 */
export const BREAKPOINTS = {
    SMALL: 375,
    MEDIUM: 768,
    LARGE: 1024,
    LARGER: 1200,
    XLARGE: 1440
};
